<iframe
  #previewFrame
  class="email-preview-frame"
  [srcdoc]="htmlSeguro"
  (load)="aoCarregar()"
  sandbox="allow-same-origin"
  matTooltip="Pré-visualização do e-mail"
  referrerpolicy="no-referrer"></iframe>
